// extracted by mini-css-extract-plugin
module.exports = {"criteriaInput":"SearchBarCriteriaInput_criteriaInput__2ik0Q","criteriaInputContainer":"SearchBarCriteriaInput_criteriaInputContainer__2QHQi"};